<template><div><h1 id="personenmerkmal-vorgabewerte" tabindex="-1"><a class="header-anchor" href="#personenmerkmal-vorgabewerte"><span>Personenmerkmal-Vorgabewerte</span></a></h1>
<p>Personenmerkmal-Positionen — Definiert Werte für Personenmerkmale</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>In dieser Tabelle werden Werte für die Personenmerkmale definiert, welche beim Erfassen von Merkmalen zu einer Adresse ausgewählt werden können. Es können nur Werte für den Typ &quot;Auswahlliste&quot; definiert werden.</p>
<p>Pfad: <code v-pre>Personen → Tabellen → Merkmale Personen</code></p>
<h2 id="datenfelder" tabindex="-1"><a class="header-anchor" href="#datenfelder"><span>Datenfelder</span></a></h2>
<dl>
<dt>Vorgabewert</dt>
<dd>Bezeichnung des Vorgabewerts</dd>
<dt>Beschreibung</dt>
<dd>Kurze Beschreibung des Vorgabewerts</dd>
<dt>Anzahl</dt>
<dd>Anzahl der Adressen im System, die mit diesem Vorgabewert versehen sind<br>Die Anzahl wird im allgemeinen automatisch nachgeführt. Ein spezieller Zähllauf existiert ebenfalls in <a class="xref" href="Systemorganisation.html#sys-adressmerkmale-korrigieren" title="7.8.7. Personenmerkmale korrigieren">Abschnitt 7.8.7, „Personenmerkmale korrigieren “</a>.</dd>
</dl>
<h2 id="funktionen" tabindex="-1"><a class="header-anchor" href="#funktionen"><span>Funktionen</span></a></h2>
<p>Standardfunktionen</p>
<h2 id="siehe-auch" tabindex="-1"><a class="header-anchor" href="#siehe-auch"><span>Siehe auch</span></a></h2>
<p><RouteLink to="/referenz/refs/ft.refdata.adrfilter.html#Filter" title="Beschreibung">Filter</RouteLink></p>
</div></template>


